import localStorageRepositories from "@/plugins/localStorageRepositories";
import { queryStoreeelAll } from "@/helpers/storeeelShadowDom";

// グループ内の全コンテンツ既読状態に応じて、外側ボーダー色のクラスを即時更新
export const updateGroupSeenBorder = (groupId) => {
  if (!groupId) return;
  const gid = String(groupId);

  // 対象グループのcontentsを、アイコン描画に使った表示用データ（prepared）から特定する。
  // 生の window.storeeelData は連携配信（フィードフォルダ）を展開する前の content を持つため、
  // 既読として記録される展開後のID（feed-folder-...）と一致せず、全部見ても既読にならない。
  // セグメントで表示対象外になった content も生データには残る。
  // prepared が無い場合（描画前など）だけ生データを見る。
  const campaigns = Array.isArray(window.storeeelData) ? window.storeeelData : [];
  let targetGroup = null;
  for (const campaign of campaigns) {
    const displayedCampaign = campaign?.__storeeelPreparedCampaignForDisplay || campaign;
    if (!Array.isArray(displayedCampaign?.contentGroups)) continue;
    const g = displayedCampaign.contentGroups.find(grp => String(grp.id) === gid);
    if (g) { targetGroup = g; break; }
  }
  if (!targetGroup || !Array.isArray(targetGroup.contents)) return;

  // 既読判定（無期限TTL）
  const seenRepo = localStorageRepositories.get('contentSeen');
  const allSeen = targetGroup.contents.length > 0 && targetGroup.contents.every(c => seenRepo?.has?.(c.id));

  // DOMのボーダーを更新（circleフレーム時のみ存在）
  // 自動スクロールのループ時はアイコンが id ごと前後に複製されるため、
  // 先頭の1件（画面外の複製）だけでなく同じグループの全ボーダーを更新する
  const borders = queryStoreeelAll(`#storeeel-icon-${gid} .storeeel-group-border`);
  borders.forEach((border) => {
    if (allSeen) {
      border.classList.add('storeeel-group-seen');
      border.classList.remove('storeeel-group-unseen');
    } else {
      border.classList.remove('storeeel-group-seen');
      border.classList.add('storeeel-group-unseen');
    }
  });
};
